/**
 * İletişim bilgisi koruması (e-posta / telefon hasatına karşı).
 *
 * Spam botlarının büyük çoğunluğu JavaScript çalıştırmaz; ham HTML ve JS
 * dosyaları üzerinde düz metin regex taraması yapar. Adres ve telefon kaynak
 * kodda düz yazıldığı sürece kolayca toplanır.
 *
 * Koruma iki katmanlı:
 *  1) Sabitler burada kodlanmış tutulur, bundle içinde düz "canozen@..."
 *     dizgesi aranarak bulunamaz.
 *  2) Değer yalnızca tarayıcıda, mount sonrasında DOM'a yazılır. Bkz.
 *     components/feature/ProtectedContact.tsx.
 *
 * Ayrıca index.html'deki JSON-LD şemalarından telefon çıkarıldı; orası
 * statik olarak sunulduğu için en kolay hasat hedefiydi.
 *
 * Bu yöntem kararlı bir saldırganı durdurmaz. Amaç otomatik toplayıcıların
 * maliyetini bu siteyi taramaya değmeyecek kadar yükseltmek.
 */

/** Kodlanmış değeri çözer. */
export function decodeContact(encoded: string): string {
  if (!encoded) return '';
  try {
    return atob(encoded).split('').reverse().join('');
  } catch {
    return '';
  }
}

/** Yeni değer kodlamak için yardımcı. Üretimde çağrılmaz. */
export function encodeContact(plain: string): string {
  return btoa(plain.split('').reverse().join(''));
}

/** Kodlanmış iletişim sabitleri. Düzenlemek için encodeContact kullanın. */
export const CONTACT = {
  istanbulEmail: 'cnQubW9jLmdzY0BuZXpvbmFj',
  budapestEmail: 'bW9jLjEwMW1laUBuZXpvbmFj',
  istanbulPhone: 'NzcwNSAyODIgMjM1IDA5Kw==',
  budapestPhone: 'ODgxOCA3MTYgMDcgNjMr',
  /** tel: bağlantısı için boşluksuz biçim */
  istanbulPhoneRaw: 'NzcwNTI4MjIzNTA5Kw==',
  budapestPhoneRaw: 'ODgxODcxNjA3NjMr',
  /** wa.me için ülke kodlu, artısız biçim */
  whatsappNumber: 'NzcwNTI4MjIzNTA5',
} as const;

/** Çözülmüş WhatsApp bağlantısı. */
export function whatsappHref(): string {
  const n = decodeContact(CONTACT.whatsappNumber);
  return n ? `https://wa.me/${n}` : '/#contact';
}

/** Görsel yer tutucu. Hidrasyon öncesi ve JS kapalıyken gösterilir. */
export function maskFor(kind: 'email' | 'phone'): string {
  return kind === 'email' ? '•••••••@•••••••' : '+90 ••• ••• ••••';
}
